class RecoveryCodesLow extends Backbone.View {
	constructor() {
		super();
		this.setElement($('.sma-js-recovery-codes-low-notification'));
	}

	static get events() {
		return { 'click .sma-js-account-settings': 'navigateToAccountSettings' };
	};

	static navigateToAccountSettings(e) {
		e.preventDefault();
		const accountSettingsUrl = reverse('account');
		window.location.href = accountSettingsUrl;
	}
}

module.exports = RecoveryCodesLow;
